import { SequencingModel } from './types/sequencingModelSchema';

export const ASYNC_SEQUENCING_MODELS = [
  SequencingModel.GEO_SECTION_SPECIFIC,
  SequencingModel.ACXIOM,
];
